module.exports = __webpack_public_path__ + "static/media/lightbulb-on.e5967df6.svg";